<template>
  <article class="user_view">
    <left-menu/>
    <modal-permission @cancel="acceptAlert"  v-if="modalPermissionActive" ></modal-permission>
    <section class="user_view__header" style="display: flex;">

       <article class="info_table" style="min-width: 0;">
            <div style="width:35%;margin-left:3%;margin-top:42px;margin-bottom:30px"  class="search_input">
                <input style="width:100%" type="text" id="myInput"  placeholder="Buscar..." v-model="textSearch">
                <img style="margin-left:-20px" src="./../../assets/img/icons/search.svg">
            </div>
            <div class="client_table__modal" style="overflow-y: hidden;">
            
            <div v-for="(client,i) in companiesFilter" style="height: 150px" :class="'active-clients'" :key="i" class="client_table__modal--card" >
                <h4 class="client_table__text--title"><b>{{client.name.toUpperCase()}}</b></h4>
                <p class="client_table__text--data"><b>{{client.city}}</b></p>
                <div  class="notification_pttoperator"  :class="{active: client.missing == true}" >
                  <VueCustomTooltip :label="client.usermissing" position="is-bottom">
                    <img src="./../../assets/img/menu/ico_bell_white.svg" class="icon animate__animated infinite animate__headShake" >
                  </VueCustomTooltip>
                </div>
                <div class="voice" :class="{active: client.record == false, color: showTemp == true && nitReceiver == client.nit }" >
                  <input type="checkbox" name="adminToggle" class="adminToggle"  
                      v-on:mousedown.prevent="sendVoice(client)" 
                      v-on:mouseup.prevent="stopVoice(client)"
                      v-on:mouseleave.prevent="stopVoice(client)"
                  />
                  <a class="" href="#" >
                    <img v-if="showTemp == true && nitReceiver == client.nit" src="./../../assets/img/icons/ico_voice.svg" style="margin-left:2px;margin-bottom:3px;" >
                    <img v-else src="./../../assets/img/menu/ico_ptt_white.svg" style="margin-top:5px;" >
                    
                  </a>
                </div>
                <h6 v-if="client.record == true">{{client.transmitter}} está hablando...</h6>
                <h6 v-if="showTemp == true && nitReceiver == client.nit">Transmitiendo 00:{{timer}}</h6>
                
            </div>
            
            
            <small v-if="companiesFilter.length == 0" style="text-align: center; margin-top:33px">
                No se han encontrado clientes con esos criterios de busqueda.
            </small>
            </div>
        </article>
        
    </section> 
  </article>
</template>

<script>
import ClientTable from './../shared/ClientTable';
import ClientAlertsTable from './../shared/ClientAlertsTable';

export default {
  data(){
    return{
        user: JSON.parse(localStorage.getItem('user')),
        Companies:[],
        textSearch:'',
        allAlarms:[],
        modalPermissionActive:false,
        transmitter: false,
        showListen: false,
        showTemp: false,
        timer:30,
        chunksptt: [],
        nitReceiver:'',
        switchVoice: true,
        switchMissing: false,
        channel:'',
        rol: localStorage.getItem('rol'),
        user_name:'', 
        user_lastname:''
   

    }
  },
  components:{
    'info-client':ClientTable,
    'info-alerts-client': ClientAlertsTable ,
 
  },

  computed: {
    companiesFilter: function() {
            var textSearch = this.textSearch;
            return this.Companies.filter(function(el) {
                return el.name.toLowerCase().indexOf(textSearch.toLowerCase()) !== -1;
            });
        },
    
  },
  
  methods:{

    getCompanies(){

        const customActions={
            get: {headers:{"Authorization": 'Bearer '+localStorage.getItem('crypto')},method: 'GET'}                   
        };
        var card=JSON.parse(localStorage.getItem("user")).id_card;      
        this.$resource('company',{},customActions).get({"id_card":card})
        .then(function(data){

            var res = data.body
            this.Companies = res.map(function (data) {
              data.record = false
              data.missing = false
              data.transmitter = ''
              data.usermissing = ''
              return data
            })

            console.log('companies', this.Companies)
        });

    },

    onCancelPermission(){
      this.modalPermissionActive=false;
    },



    acceptAlert(){

      let me = this;

      me.modalPermissionActive = false;

      //socket del emisor de audio
        me.$socket.on("companyTransmitter", function(data) {
              if(data){
                   console.log('transmitter',data)

                if( data.rol == 'operator' || data.rol == 'coord'){
                     if(data.record == true){

                        var channelformater = data.canal.split('/') 
                        me.channel = channelformater[1]
                        console.log('channelformater[1]', channelformater[1])

                        var item = me.Companies.find(item => item.nit == me.channel)
                        console.log('item', item)
                        const index = me.Companies.indexOf(item)
                        me.Companies[index].record = true
                        me.Companies[index].transmitter = data.name

                        console.log(' me.switchVoice',  me.switchVoice)

                       //si el operario está escuchando por alguno de los contratos las demás transmisiones quedan como llamadas perdidas
                        if( me.switchVoice == false){
                          me.Companies[index].missing = true
                          me.Companies[index].usermissing = data.name
                        }

                        // me.getVoice('play');
                                              
                        if( me.switchVoice == true && me.showTemp == false){
                          me.getVoice('play');
                        }

                        
                        //si el operario está hablando por alguno de los contratos las demás transmisiones quedan como llamadas perdidas
                        if(me.showTemp == true ){
                            me.Companies[index].missing = true
                        }



                     }else if( data.record == false ){

                        me.switchVoice = true
                        // console.log(' me.switchVoice en false',  me.switchVoice)
                        // me.$socket.off("voice/"+me.channel)
                        me.getVoice('stop');                        
                        var item = me.Companies.find(item => item.nit == me.channel)
                        if(item){
                          const index = me.Companies.indexOf(item)
                          me.Companies[index].record = false
                          me.Companies[index].transmitter = ''
                          me.channel = ''

                          //si el operario está hablando por alguno de los contratos las demás transmisiones quedan como llamadas perdidas
                          if(me.showTemp == true ){
                              me.Companies[index].missing = true
                              me.Companies[index].usermissing = data.name
                          }
                        }


                     } 

                }else{

                  
                     if(data.record == true){

                        var item = me.Companies.find(item => item.nit === data.company)
                        const index = me.Companies.indexOf(item)
                        me.Companies[index].record = true
                        me.channel = data.company
                        me.Companies[index].transmitter = data.name

                        //si el operario está escuchando por alguno de los contratos las demás transmisiones quedan como llamadas perdidas
                        if( me.switchVoice == false){
                          me.Companies[index].missing = true
                          me.Companies[index].usermissing = data.name
                        }

                        if( me.switchVoice == true && me.showTemp == false){
                          me.getVoice('play');
                        }

                        //si el operario está hablando por alguno de los contratos las demás transmisiones quedan como llamadas perdidas
                        if(me.showTemp == true ){
                            me.Companies[index].missing = true
                            me.Companies[index].usermissing = data.name
                        }

                        
                    }else if( data.record == false ){
                      
                        var item = me.Companies.find(item => item.nit === data.company)
                        if(item){
                          const index = me.Companies.indexOf(item)
                          me.Companies[index].record = false
                          me.channel = ''
                          me.Companies[index].transmitter = ''
                          me.switchVoice = true

                        //si el operario está hablando por alguno de los contratos las demás transmisiones quedan como llamadas perdidas
                          if(me.showTemp == true ){
                              me.Companies[index].missing = true
                              me.Companies[index].usermissing = data.name
                          }

                        }

                    }

                }
                

              }
        });


    },


    sendVoice(data){

        let me = this;
        var nit = data.nit
        var company;

        if(me.rol == 'coord' ){
           company = 1;
        }
        if(me.rol == 'operator' ){
           company = 2;
        }

        //validamos si tiene una llamada perdida para quitar la notificación
       if( data.missing == true){
          const index = me.Companies.indexOf(data)
          me.Companies[index].missing = false
        }
        
        //detener recepcion de voz
        me.getVoice('stop');
        
        me.nitReceiver = data.nit

        
        
          //socket del emisor de audio
         me.$socket.emit("transmitter", {
            canal: "transmitter/"+nit,
            record: true,
            name: me.user_name+' '+me.user_lastname,
            company: company,
            rol: me.rol
          });

         var constraints = { 
            audio: {
            channelCount: 2,
             volume: 1.0,
             sampleRate: 48000,
             echoCancellation: true,
             noiseSuppression: true,
             autoGainControl: false
            } 
          };

            navigator.mediaDevices.getUserMedia(constraints).then(function(mediaStream) {

                me.mediaStream = mediaStream;
                  
                    var mediaRecorder = new MediaRecorder(mediaStream);

                    mediaRecorder.onstart = function(e) {
                        me.chunksptt = [];
                    };

                    mediaRecorder.ondataavailable = function(e) {
                        me.showTemp = true;

                        me.chunksptt.push(e.data);
                        console.log('ondataavailable', e.data)
                    };
                    mediaRecorder.onstop = function(e) {
                        var blob = new Blob(me.chunksptt, { 'type' : 'audio/ogg; codecs=opus' });
                        me.$socket.emit("voice", {
                          canal: "voice/"+nit,
                          mensaje: blob,
                        });

    
                    };

                    // Start recording
                    mediaRecorder.start()

                    me.intervalId = setInterval(function() {
                      if( me.timer != 0){
                        mediaRecorder.stop()
                        mediaRecorder.start()
                        me.timer --;
                        console.log('ejecucion',me.timer)
                      }else{
                        me.showTemp = false;
                        mediaRecorder.stop()
                        me.transmitter = false;
                        me.timer = 30;
                        clearInterval(me.intervalId);
                        me.disconnectSocketAudio(nit)
                        me.nitReceiver = ''
                        console.log('deberia finalizar',me.intervalId)
                        //ocultar icono de grabación
                        mediaStream.getTracks().forEach( track => track.stop() );
                        me.getVoice('play');  
                      }
                        
                    }, 1000);


                }).catch((error) => {


                });
    },


    stopVoice(data){
      let me = this;
      var nit = data.nit
      me.showTemp = false;
      me.nitReceiver = ''
      //cerrar socket
      me.disconnectSocketAudio(nit)

     
      console.log('recording',me.transmitter )
      me.timer = 30;
      clearInterval(me.intervalId);
      console.log('stop record')

      me.getVoice('play'); 

      me.switchVoice = true;

      //socket del emisor de audio
      me.$socket.emit("transmitter", {
          canal: "transmitter/"+nit,
          record: false,
          name: me.user_name+' '+me.user_lastname,
          company: me.company_nit,
          rol: me.rol
      });

    },


    getVoice(data){

        let me = this;


        if( data == 'play'){

          console.log('a escuchar')

          me.switchVoice = false

          me.$socket.on("voice/"+me.channel, function(arrayBuffer) {
          if(arrayBuffer){

                console.log('esta llegando a el canal',arrayBuffer.mensaje)
                var blob = new Blob([arrayBuffer.mensaje], { 'type' : 'audio/ogg; codecs=opus' });
                var audio = document.createElement('audio');
                audio.src = window.URL.createObjectURL(blob);
                audio.play();


            }

          });
        }else if( data == 'stop'){
          
          //cerrar socket para evitar escuchar transmisiones mientras se habla
          me.$socket.off("voice/"+me.channel)

        }



  },   

  disconnectSocketAudio(data){
      //cerrar socket para evitar escuchar transmisiones mientras se habla
      this.$socket.off("voice/"+data)
  },

 
  },
  created(){

    var user_name = this.user.name.split(' ');
    this.user_name = user_name[0]

    var user_lastname = this.user.last_name.split(' ');
    this.user_lastname = user_lastname[0]


   //solicitar permisos de micrófono

   var constraints = { audio: true };
                      
    navigator.mediaDevices.getUserMedia(constraints).then(function(mediaStream) { 
      mediaStream.getTracks().forEach( track => track.stop() );
    });
    
   this.getCompanies();
   this.modalPermissionActive =true
  },



  
}
</script>

<style scoped>
.adminToggle {
        -webkit-appearance: none;
        position: absolute;
        border-radius: 50%;
        top: 0; left: 0;
        margin: 0;
        width: 100%;
        height: 100%;
        cursor: pointer;
        background-color: transparent;
        border: none;
        outline: none;
        z-index: 2;
        transition: box-shadow .2s ease-in-out;
        box-shadow: 0 3px 5px 1px rgba(51, 51, 51, .3);
      }



.icon{
  width: 70%;
}

</style>


// WEBPACK FOOTER //
// src/components/pages/Ptt.vue